import { optionsTransformer } from 'module/helpers/filter/option-transformer';
import {
  SingleSelectField,
  SingleUserField,
} from 'module/types/filter-field/field/filterable-field';
import { SelectFilterOperationType } from 'module/types/filter-field/filter/select';
import { SingleSelectFieldFilter } from 'module/types/filter-field/filter/single-select';
import { SingleUserFieldFilter } from 'module/types/filter-field/filter/single-user';
import { FC } from 'react';
import { SingleSelectBaseCriteria } from './single-select-base';
import { TagEditorComponents } from '../../field-editors/default-editor-components';
import { EditorComponents } from '../../field-editors/types';

interface Props {
  filter: SingleSelectFieldFilter;
  onChange: (filter: SingleSelectFieldFilter) => void;
  components?: EditorComponents;
  getFilterOperationTypeOptions?: (
    field: SingleUserField | SingleSelectField,
  ) => SingleUserFieldFilter[] | SingleSelectFieldFilter[];
  getOperationOptionRenderer?: (
    type: SelectFilterOperationType,
  ) => null | React.JSX.Element;
}

export const SingleSelectCriteria: FC<React.PropsWithChildren<Props>> = ({
  filter,
  onChange,
  components,
  getFilterOperationTypeOptions,
  getOperationOptionRenderer,
}) => (
  <SingleSelectBaseCriteria
    components={{ ...TagEditorComponents, ...components }}
    filter={filter}
    onChange={onChange as any}
    options={optionsTransformer(filter.field).options.activeOptions}
    getFilterOperationTypeOptions={getFilterOperationTypeOptions}
    getOperationOptionRenderer={getOperationOptionRenderer}
    type="tag"
  />
);
